require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-how-much-car-can-i-afford.json") })
        }
      }, "path---calculators-how-much-car-can-i-afford");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-how-much-car-can-i-afford!./.cache/json/calculators-how-much-car-can-i-afford.json
// module id = 2005
// module chunks = 231608221292675